var isDesktop = require("./is-desktop");

function isMobile() {
    var max = 1023;
    var biggestScreenSide = (window.screen.width > window.screen.height) ? window.screen.width : window.screen.height;

    return (!isDesktop() && biggestScreenSide <= max);
}
module.exports = isMobile;